module.exports = __webpack_public_path__ + "static/media/buttonProduct_grow.9e094073.png";